module.exports = "/images/user.png?c144886893624a26ee9640b7639974cd";